// Single source of truth for the Create Company wizard steps.
// Step 1 (PROFILE) is its own route (CompanyCreation); steps 2-5 live inside
// the CompanyCategories route and are switched via `activePage`, whose values
// match the `key`s below (CATEGORIES / STOCKS / SOCIALS / MEMBERS).
export const COMPANY_WIZARD_STEPS = [
  {key: 'PROFILE', label: 'Profile'},
  {key: 'CATEGORIES', label: 'Topics'},
  {key: 'STOCKS', label: 'Stock', optional: true},
  {key: 'SOCIALS', label: 'Socials', optional: true},
  {key: 'MEMBERS', label: 'Founders'},
];

export const stepIndex = key =>
  COMPANY_WIZARD_STEPS.findIndex(step => step.key === key);
